module.exports = __webpack_public_path__ + "static/pro-develop-banner@2x-ca51f9bbcf9006e3a8236e86ac1e417a.png";